export function addMessageAndUpdateWinners(
  authors,
  winnerAuthors,
  message,
  sizeWin
) {
  const { id } = message;
  const { senderNumber, author, broadcast_id, image, channel } =
    message.message;

  const existingAuthorIndex = authors.findIndex(
    (a) => a.author === author && a.senderNumber === senderNumber
  );

  let updatedAuthor;

  if (existingAuthorIndex !== -1) {
    const existingAuthor = authors[existingAuthorIndex];
    const broadcastIdExists = existingAuthor.broadcastIds.some(
      (item) => Object.values(item)[0] === broadcast_id
    );

    if (!broadcastIdExists) {
      existingAuthor.broadcastIds.push({ [id]: broadcast_id });
      updatedAuthor = existingAuthor;
    }
  } else {
    updatedAuthor = {
      author,
      image,
      channel,
      senderNumber,
      id: senderNumber,
      broadcastIds: [{ [id]: broadcast_id }],
    };
    authors.push(updatedAuthor);
  }

  if (updatedAuthor) {
    updateWinnerAuthors(winnerAuthors, updatedAuthor, sizeWin);
  }
}

// Функция обновления победителей
function updateWinnerAuthors(winnerAuthors, author, sizeWin = 2) {
  const uniqueBroadcastIds = new Set(
    author.broadcastIds.map((item) => Object.values(item)[0])
  );

  const isWinner = uniqueBroadcastIds.size === sizeWin;
  const alreadyInWinners = winnerAuthors.some(
    (winner) =>
      winner.author === author.author &&
      winner.senderNumber === author.senderNumber
  );

  if (isWinner && !alreadyInWinners) {
    winnerAuthors.push({ ...author });
  } else if (!isWinner && alreadyInWinners) {
    // Удаляем из победителей если больше не подходит
    const winnerIndex = winnerAuthors.findIndex(
      (winner) =>
        winner.author === author.author &&
        winner.senderNumber === author.senderNumber
    );
    if (winnerIndex !== -1) {
      winnerAuthors.splice(winnerIndex, 1);
    }
  }
}

// Функция удаления сообщений
export function removeMessages(
  authors,
  winnerAuthors,
  deletedMessagesIdList,
  sizeWin
) {
  deletedMessagesIdList.forEach((deletedId) => {
    // Ищем автора у которого есть сообщение с таким id
    for (let i = 0; i < authors.length; i++) {
      const author = authors[i];
      const messageIndex = author.broadcastIds.findIndex(
        (item) => Object.keys(item)[0] === String(deletedId)
      );

      if (messageIndex !== -1) {
        // Удаляем сообщение из broadcastIds
        author.broadcastIds.splice(messageIndex, 1);

        // Если у автора не осталось сообщений - удаляем автора полностью
        if (author.broadcastIds.length === 0) {
          authors.splice(i, 1);
          i--; // Корректируем индекс после удаления

          // Удаляем автора из победителей если он там был
          removeAuthorFromWinners(
            winnerAuthors,
            author.author,
            author.senderNumber
          );
        } else {
          // Обновляем статус победителя
          updateWinnerAuthors(winnerAuthors, author, sizeWin);
        }
        break; // Сообщение может быть только у одного автора
      }
    }
  });
}

// Вспомогательная функция удаления автора из победителей
function removeAuthorFromWinners(winnerAuthors, author, senderNumber) {
  const winnerIndex = winnerAuthors.findIndex(
    (winner) => winner.author === author && winner.senderNumber === senderNumber
  );

  if (winnerIndex !== -1) {
    winnerAuthors.splice(winnerIndex, 1);
  }
}

// Функция для получения уникальных broadcast_id автора
function getUniqueBroadcastIds(author) {
  return new Set(author.broadcastIds.map((item) => Object.values(item)[0]));
}
